import "./GarageDoorRepairWesternSydney.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import GarageHero from "./sections/GarageHero";
import GarageServices from "./sections/GarageServices";
import Partners from "./sections/Partners";
import GarageProcess from "./sections/GarageProcess";
import WhyUs from "./sections/WhyUs";
import Showcase from "./sections/Showcase";
import Reviews from "./sections/Reviews";
import Faq from "./sections/Faq";
import GarageCta from "./sections/GarageCta";
import CompanyBrandingFooter from "./sections/CompanyBrandingFooter";
export default function GarageDoorRepairWesternSydneyPage() {
  return <div>
      <Header />
      <Hero />
      <GarageHero />
      <GarageServices />
      <Partners />
      <GarageProcess />
      <WhyUs />
      <Showcase />
      <Reviews />
      <Faq />
      <GarageCta />
      <CompanyBrandingFooter />
    </div>;
}